/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getActorFeeds.defs.js'
export { main as default } from './getActorFeeds.defs.js'
